/**
 * create-group-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class CreateGroupRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_CREATE_GROUP;
	public static tag : MessageTag = MessageTag.REQ_CREATE_GROUP;

  /**
   * Construct a new {@link CreateGroupRequest}.
   */
  constructor (
    public name : string,
    public objectId : number,
    public copyContacts : boolean
  )
  {
    super();
    throw new Error("This message is reserved but unimplemented.");
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/group-management/create-group-request.ts